/**
 * INSTRUCTIONS D'INSTALLATION :
 *
 * 1. ajouter ce fichier dans le dossier des assets de votre thème
 * 2. ajouter au fichier theme.liquid après *locator.js* (REQUIRED) :
 *     <script type="module" src="{{ 'shipping-location-handler.js' | asset_url }}"></script>
 *
 * 3. ajouter à votre élément de texte d'expédition :
 *    <span *="" data-shipping-text="" Then="" add="" the="" countries="" data="" attributes="" for="" example:="" data-shipping-de="{{ section.settings.shipping_text_below_threshold_de | times: 100 }}" data-shipping-default="{{ section.settings.shipping_text_below_threshold_all | times: 100 }}"></span>
 *
 * 4. Update formatMoney() and getShippingAmount() methods to return the correct data attributes
 *    (see below)
 *
 * 5. Add to section schema:
 *    {
 *      "type": "text",
 *      "id": "shipping_text_below_threshold_de",
 *      "label": "Shipping value below threshold DE",
 *      "default": "4.90"
 *    },
 *    {
 *      "type": "text",
 *      "id": "shipping_text_below_threshold_all",
 *      "label": "Shipping value below threshold all",
 *      "default": "14.90"
 *    }
 */

(() => {
  class ShippingTextUpdater {
    constructor() {
      this.shippingTextElement = document.querySelector('[data-shipping-text]');

      if (!this.shippingTextElement) {
        console.warn('[ShippingTextUpdater] Shipping text element not found');
        return;
      }

      // Listen for location updates
      window.addEventListener('userLocationDetected', (event) => {
        this.updateShippingText(event.detail);
      });
    }

    getStoredLocation() {
      try {
        const storedLocation = localStorage.getItem('userCountryCode');
        return storedLocation ? storedLocation : null;
      } catch (error) {
        console.warn('[ShippingTextUpdater] Error accessing localStorage:', error);
        return null;
      }
    }

    formatMoney(amount, countryCode) {
      const value = (amount / 100).toFixed(2).replace('.', ',');
      switch (countryCode) {
        case 'CH':
          return `CHF ${value}`;
        default:
          return `€${value}`;
      }
    }

    getShippingAmount(countryCode) {
      const amounts = {
        DE: this.shippingTextElement.dataset.shippingDe,
        CH: this.shippingTextElement.dataset.shippingCh,
        DEFAULT: this.shippingTextElement.dataset.shippingDefault
      };

      const amount = amounts[countryCode] || amounts.DEFAULT;
      return amount;
    }

    updateShippingText(locationData) {
      // Clean the location data by removing any extra quotes
      const cleanLocationData = locationData ? locationData.replace(/"/g, '') : null;

      // Always ensure we have a valid country code
      const countryCode = (cleanLocationData && typeof cleanLocationData === 'string') ? cleanLocationData : 'DEFAULT';
      console.log('[ShippingTextUpdater] Resolved country code:', countryCode);

      try {
        const amount = this.getShippingAmount(countryCode);

        if (!amount) {
          throw new Error('No shipping amount found');
        }

        const formattedAmount = this.formatMoney(amount, countryCode);
        this.shippingTextElement.textContent = `${formattedAmount}`;
      } catch (error) {
        // Fallback to default amount
        const defaultAmount = this.shippingTextElement.dataset.shippingDefault;
        if (defaultAmount) {
          const formattedAmount = this.formatMoney(defaultAmount, 'DEFAULT');
          this.shippingTextElement.textContent = `${formattedAmount}`;
        }
      }
    }
  }

  // Initialize on DOM load
  document.addEventListener('DOMContentLoaded', () => {
    new ShippingTextUpdater();
  });

  document.addEventListener('cart:change', () => {
    const updater = new ShippingTextUpdater();

    if (updater.shippingTextElement) {
      const storedLocation = updater.getStoredLocation();
      updater.updateShippingText(storedLocation);
    }
  });
})();
